import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import TemplateForm from 'pages/TemplateForm';
import { setActiveTab } from 'state/actions/tab';
import './index.css';

function Template() {
  const { templateId, siteId, siteName } = useParams();
  const isEditing =
    templateId !== undefined && templateId !== null && templateId !== 'new';
  const dispatch = useDispatch();

  dispatch(setActiveTab({ tab: 'template' }));

  return (
    <div className="media">
      <div className="media-header">
        <h1>{isEditing ? 'Edit Template' : 'Add New Template'}</h1>
        <Link
          to={`/${siteId}/information/${siteName}/`}
          className="button-secondary"
        >
          <i className="feather-arrow-left" />
          Back
        </Link>
      </div>
      <div className="media-content">
        <TemplateForm isEditing={isEditing} />
      </div>
    </div>
  );
}

export default Template;
